import type { Ticker } from '../store/heatmapStore';

export const DEFAULT_SELECTED_TICKER: Ticker = 'SPY';

const SELECTED_TICKER_STORAGE_PREFIX = 'mvai:selected-ticker';
const TICKER_PATTERN = /^[A-Z][A-Z0-9.-]{0,15}$/;

export function getSelectedTickerStorageKey(userId: string, host: string): string {
  return `${SELECTED_TICKER_STORAGE_PREFIX}:${encodeURIComponent(host)}:${encodeURIComponent(userId)}`;
}

function normalizeStoredTicker(value: string): Ticker | null {
  const ticker = value.trim().toUpperCase();
  return TICKER_PATTERN.test(ticker) ? ticker : null;
}

export function readSelectedTickerPreference(userId: string | null): Ticker {
  if (typeof window === 'undefined' || userId === null || userId === '') {
    return DEFAULT_SELECTED_TICKER;
  }

  try {
    const key = getSelectedTickerStorageKey(userId, window.location.host);
    const storedTicker = window.localStorage.getItem(key);
    return storedTicker == null
      ? DEFAULT_SELECTED_TICKER
      : (normalizeStoredTicker(storedTicker) ?? DEFAULT_SELECTED_TICKER);
  } catch {
    return DEFAULT_SELECTED_TICKER;
  }
}

export function writeSelectedTickerPreference(userId: string | null, ticker: Ticker): void {
  if (typeof window === 'undefined' || userId === null || userId === '') {
    return;
  }

  const normalizedTicker = normalizeStoredTicker(ticker);
  if (normalizedTicker == null) {
    return;
  }

  try {
    const key = getSelectedTickerStorageKey(userId, window.location.host);
    window.localStorage.setItem(key, normalizedTicker);
  } catch {
    // A blocked or unavailable storage API must not prevent the live app from loading.
  }
}
